module.exports = __webpack_public_path__ + "img/2-ilpakamaniotro_thumb.15bc7195.jpg";